import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SquareButton = function SquareButton(props) {
  // determine if button should be centered with auto margins (only if button is not inline)
  const centered = props.config.centered ? 'centered' : '';
  // determine if button should use display: inline-block
  const inline = props.config.inline ? 'inline' : '';
  // determine which CSS class to use
  const {buttonStyle} = props.config;
  const buttonWidth = props.config.fixedWidth ? 'btn-fixed-width' : '';
  // determine if any CSS properties should be set in the style attribute
  const customStyles = {};
  if (props.config.width) {
    customStyles.width = props.config.width;
  }
  const btnClass = classNames('btn', buttonStyle, centered, inline, buttonWidth);
  return (
    <button className={btnClass} onClick={props.handleClick} style={customStyles}>
      {props.children}
    </button>
  );
};

SquareButton.propTypes = {
  handleClick: PropTypes.func,
  config: PropTypes.object,
  children: PropTypes.node,
};

SquareButton.defaultProps = {
  config: {},
};

export default SquareButton;
